import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CTAButtons = ({ primaryText, primaryLink, secondaryText, secondaryLink, primaryOnClick, secondaryOnClick }) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
      {primaryOnClick ? (
        <button
          onClick={primaryOnClick}
          className="group relative px-8 py-4 bg-gradient-to-r from-orange-300 via-orange-400 to-amber-400 hover:from-yellow-300 hover:to-orange-400 text-gray-900 font-bold text-lg rounded-lg shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-yellow-500/50 active:scale-95"
        >
          <span className="flex items-center gap-2">
            {primaryText}
            <motion.svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              animate={{ x: [0, 10, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </motion.svg>
          </span>
        </button>
      ) : (
        <Link
          to={primaryLink}
          className="group relative px-8 py-4 bg-gradient-to-r from-orange-300 via-orange-400 to-amber-400 hover:from-yellow-300 hover:to-orange-400 text-gray-900 font-bold text-lg rounded-lg shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-yellow-500/50 active:scale-95"
        >
          <span className="flex items-center gap-2">
            {primaryText}
            <motion.svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              animate={{ x: [0, 3, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </motion.svg>
          </span>
        </Link>
      )}
      {secondaryOnClick ? (
        <button
          onClick={secondaryOnClick}
          className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-all duration-300"
        >
          {secondaryText}
        </button>
      ) : (
        <Link
          to={secondaryLink}
          className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-all duration-300"
        >
          {secondaryText}
        </Link>
      )}
    </div>
  );
};

export default CTAButtons;